// src/components/misc/Loader.jsx
export default function Loader() {
  return (
    <div className="flex items-center justify-center py-6">
      <div className="w-6 h-6 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
